import React, { useState, useEffect } from 'react';
import {useLocation} from 'react-router-dom';
import {Row, Col, Spin} from 'antd';
import { confirmar_Asistencia_mesa_directiva } from '../../utils/ConexionServidor';

import banner_home from '../../assets/images/sitio/RecursosIES_completo/Ies_BannerREGISTRO_completo.jpg';
import banner_movil_home from '../../assets/images/sitio/RecursosIES_completo/Ies_BannerREGISTRO_completo.jpg';

const MesasDirectivas = (props) => {

    const [cargando, setCargando] = useState(true);
    const [estado, setEstado] = useState(-1);
    const {idioma} = props;
    const location = useLocation();

    useEffect(()=>{

        if(location.hash.replace('#', '') !== ''){
            confirmar_Asistencia_mesa_directiva({token:location.hash.replace('#', '')}).then(data => {
                setCargando(false);
                setEstado(data.status);
            });
        }else{
            setEstado(3);
            setCargando(false);
        }
        
    },[]);

    return(
        <Spin spinning={cargando} delay={0}>
        <Row>
        <Col xs={0} md={24}>
      <img src={banner_home} alt="" style={{width:'100%'}} />
      </Col>
      <Col xs={24} md={0}>
      <img src={banner_movil_home} alt="" style={{width:'100%'}} />
      </Col>
            <Col xs={{span:22, offset:1}} md={{span:20, offset:2}}>
                <br />
                <p style={{fontSize:'18px'}}>
                    {estado === -1 ?
                        idioma === 'es' ? 'Cargando' : 'Loading'
                    :
                    estado === 0 ?
                        idioma === 'es' ?
                        <>
                            Tu asistencia ha quedado confirmada, guarda los siguientes datos para conectarte a las mesas cruzadas en la plataforma Zoom:
<br /><br />
Tema: IES Mesas cruzadas <br />
Hora: 21 abr. 2021 11:00 a. m. Ciudad de México 
 <br /><br />
Link:<br />
<a target="_blank" href="https://us02web.zoom.us/j/84613249990?pwd=U0gyOHFONDFpa3BzK1N6SEVxNFo4dz09 ">https://us02web.zoom.us/j/84613249990?pwd=U0gyOHFONDFpa3BzK1N6SEVxNFo4dz09</a>
 <br /><br />
ID de reunión: 846 1324 9990 <br />
Código de acceso: 598892
                        </>
                        :
                      
                        <>
                        Your attendance has been confirmed, save the following data to connect to the cross tables on the Zoom platform:
<br /><br />
Theme: IES Mesas cruzadas <br />
Time: Apr 21. 2021 11:00 a. m. Mexico City
 <br /><br />
Link:<br />
<a target="_blank" href="https://us02web.zoom.us/j/84613249990?pwd=U0gyOHFONDFpa3BzK1N6SEVxNFo4dz09 ">https://us02web.zoom.us/j/84613249990?pwd=U0gyOHFONDFpa3BzK1N6SEVxNFo4dz09</a>
 <br /><br />
 Meeting ID: 846 1324 9990 <br />
 Access code: 598892
                        </>
                    :
                    estado === 1 ?
                        idioma === 'es' ? 
                        <>
                            Tuvimos problemas para confirmar tu asistencia, por favor inténtalo más tarde.
                        </>
                        :
                        <>
                            We had trouble RSVP, please try again later.
                        </>
                    :
                    estado === 2 ?
                        idioma === 'es' ? 
                        <>
                            Agradecemos tu interés, pero las mesas directivas han sido ocupadas en su totalidad.
                        </>
                        :
                        <>
                            We appreciate your interest, but the boards of directors have been fully occupied.
                        </>
                    :
                    estado === 3 &&
                        idioma === 'es' ? 
                        <>
                            No tiene permiso para acceder a este contenido.
                        </>
                        :
                        <>
                            You do not have permission to access this content.
                        </>
                    
                }
                </p>
            </Col>
        </Row>
        </Spin>
    );
}

export default MesasDirectivas;
